import { omit } from 'lodash'

/** 套餐类型 */
export const SUB_TYPES = {
  /**试用 */
  trial: 'trial',
  /**付费 */
  paid: 'paid',
}

/**套餐状态*/
export const SUB_STATUS = {
  /**未支付 */
  pending: 'pending',
  /**生效中 */
  active: 'active',
  /**过期 */
  expired: 'expired',
  /**失效 */
  unactive: 'unactive',
  /**取消 */
  cancelled: 'cancelled',
}

/** 绑卡状态 */
export const BIND_STATUS = {
  /**INIT */
  INIT: 0,
  /**PROCESSING */
  PROCESSING: 100,
  /**SUCCEEDED */
  SUCCEEDED: 200,
  /**FAILED */
  FAILED: 300,
  /**EXPIRED */
  EXPIRED: 400,
  /**UN_BIND */
  UN_BIND: 500,
  /**UN_KNOW */
  UN_KNOW: 600,
}

/** 期限类型 */
export const DURATION_TYPES = {
  /**月付 */
  monthly: 'monthly',
  /**年付 */
  year: 'year',
}

/** serviceKey类型 */
export const SERVICE_KEYS = {
  /** sms权益 在lms写死了是os_sms_meg，跟系统无关  */
  ow_sms_meg: 'os_sms_meg',
}

export const PRODUCT_LINE = {
  /**serviceKey: productLine */
  ow_dy_free: 'ow_dy_free',

  ow_sms_meg: 'ow_sms_meg',
}

export const PRODUCT_LINE_ARRAY = Object.keys(PRODUCT_LINE)

// 套餐等级
// export const PRODUCT_LEVEL = {
//   os_dy_free: 1,
//   os_dy_plus: 2,
//   os_dy_pro: 3,
// }

export const SERVICE_TYPES = {
  /**订阅类 */
  SUB: 1,
  /**服务类 */
  SERVICE: 2,
}

export const SETTLE_MENT_SDK_ENV_MAP: Record<string, 'dev' | 'test' | 'prev' | 'prod'> = {
  develop: 'dev',
  test: 'test',
  preview: 'prev',
  product: 'prod',
}

export const BILL_STATUSES = {
  /**未支付 */
  pending: 100,
  /**已支付 */
  paid: 200,
  /**已取消 */
  cancelled: 300,
} as const

export const BILL_TYPES = {
  /**订阅类 */
  SUB: 5,
  /**服务类 */
  SERVICE: 6,
} as const

export const BILL_STATUS_TAGS = {
  [BILL_STATUSES.pending]: {
    color: 'warning',
  },
  [BILL_STATUSES.paid]: {
    color: 'success',
  },
  [BILL_STATUSES.cancelled]: {
    color: 'default',
  },
}

export const FLOW_ACTION_TYPES = {
  /**
   * 加购
   */
  PURCHASE: 'purchase',
  /**
   * 过期
   */
  EXPIRED: 'expired',
  /**
   * 扣减
   */
  DEDUCTION: 'deduction',
  /**
   * 加回
   */
  ADDBACK: 'addback',
} as const

/**
 * 账单流水操作符
 */
export const FLOW_OPERAND_FLAG = {
  [FLOW_ACTION_TYPES.PURCHASE]: '+',
  [FLOW_ACTION_TYPES.DEDUCTION]: '-',
  [FLOW_ACTION_TYPES.ADDBACK]: '+',

  [FLOW_ACTION_TYPES.EXPIRED]: '-',
}

/**
 * 账单默认查询参数,
 * 用于账单列表页,
 * 只查询服务订单
 */
export const BILLS_DEFAULT_QUERY = {
  billTypes: [BILL_TYPES.SERVICE],
}

export const SMS_FLOW_SERVICE_KEYS = ['os_sms_meg']

export const SEARCHABLE_FLOW_ACTION_TYPES = omit(FLOW_ACTION_TYPES, ['EXPIRED'])

/**
 * 账单流水可搜索的操作类型
 */
export const SMS_FLOW_ALL_ACTION_TYPES = Object.values(SEARCHABLE_FLOW_ACTION_TYPES)

export const SMS_FLOW_ACTION_TAGS = {
  [FLOW_ACTION_TYPES.PURCHASE]: {
    color: 'success',
  },
  [FLOW_ACTION_TYPES.DEDUCTION]: {
    color: 'lightBlue',
  },
  [FLOW_ACTION_TYPES.ADDBACK]: {
    color: 'error',
  },

  [FLOW_ACTION_TYPES.EXPIRED]: {
    color: 'default',
  },
}

export const SMS_FLOW_SCENES = {
  /**
   * 已发货
   */
  notify_sms_delivered: 'notify_sms_delivered',
  /**
   * 已到达
   */
  notify_sms_arrived: 'notify_sms_arrived',
  /**
   * 已签收
   */
  notify_sms_received: 'notify_sms_received',
  /**
   * 门店关转
   */
  notify_sms_station_closed: 'notify_sms_station_closed',
  /**
   * 门店更换
   */
  notify_sms_station_changed: 'notify_sms_station_changed',
}
